/* In den Warenkorb legen, ohne die Seite neu zu laden, und die Schublade
 * (Mini-Warenkorb) bedienen.
 *
 * Emir 2026-08-11: vorher sprang die Seite nach dem Klick nach ganz oben, weil
 * `return_to=back` zwar auf derselben Seite bleibt, sie aber neu laedt.
 *
 * Emir 2026-08-12: dazu die Schublade. Nach dem Anlegen sieht der Kunde jetzt
 * sofort, was im Korb liegt, und kommt mit einem Klick zur Kasse, ohne die
 * Produktseite zu verlassen.
 *
 * Fortschrittliche Verbesserung, kein Muss: die Formulare funktionieren
 * weiterhin ganz normal, wenn dieses Skript nicht laedt oder JavaScript aus
 * ist. Dann greift wieder `return_to=back`, und der Warenkorbknopf im Kopf
 * bleibt ein gewoehnlicher Link auf die Warenkorbseite. Deshalb wird hier nur
 * der Absendevorgang abgefangen, nichts umgebaut.
 *
 * Bewusst ohne Alpine und ohne Abhaengigkeit: das laeuft auf jeder Seite, auch
 * dort wo Alpine spaeter oder gar nicht kommt. Der Zustand der Schublade
 * haengt an EINER Klasse am aeusseren Element, nicht an einem Rahmenwerk. So
 * ueberlebt er auch den HTML-Tausch beim Aendern der Menge.
 *
 * GF 2026-09-22: dazu die eingetippte Menge (Schublade und Warenkorbseite)
 * und die Versandkosten vorab per PLZ (Abschnitt "Versandkosten vorab").
 *
 * Den Inhalt der Schublade rendert Liquid, nicht dieses Skript: die
 * Section Rendering API (`sections=gs-minicart` an der Mutation) liefert
 * fertiges HTML zurueck. Damit gibt es keine zweite Stelle, an der Preise
 * formatiert werden.
 */
(function () {
  'use strict';

  var ZAEHLER = '.gs-header__cart-count';
  var KORB = '.gs-header__cart';
  var SCHUBLADE = '[data-gs-minicart]';
  var INHALT = '[data-gs-minicart-inhalt]';
  var SEKTION = 'gs-minicart';

  var letzterFokus = null;

  function schublade() {
    return document.querySelector(SCHUBLADE);
  }

  function warenkorbAdresse() {
    var link = document.querySelector(KORB);
    return link ? link.getAttribute('href') : '/cart';
  }

  function zaehlerSetzen(anzahl) {
    var el = document.querySelector(ZAEHLER);
    if (!el) {
      // Bei leerem Warenkorb rendert Liquid die Blase gar nicht erst.
      var korb = document.querySelector(KORB);
      if (!korb) return;
      el = document.createElement('span');
      el.className = 'gs-header__cart-count';
      korb.appendChild(el);
    }
    el.textContent = anzahl;
    el.hidden = anzahl < 1;
    // Kurzes Aufploppen. Die Kennbilder dafuer stehen schon in der
    // Tailwind-Konfiguration (animation: cart-bump).
    el.classList.remove('animate-cart-bump');
    void el.offsetWidth; // Neustart der Abspielung erzwingen
    el.classList.add('animate-cart-bump');
  }

  // Die Anzahl im Kopf der Schublade. Steht bewusst AUSSERHALB des
  // ausgetauschten Bereichs, damit der Fokus auf dem Schliessen-Knopf beim
  // Mengenwechsel nicht ins Leere faellt.
  function zahlSetzen(anzahl) {
    var el = document.querySelector('[data-gs-minicart-zahl]');
    if (el) el.textContent = '(' + anzahl + ' Artikel)';
  }

  function rueckmeldung(knopf, text) {
    if (!knopf) return;
    var alt = knopf.getAttribute('data-alt-text');
    if (alt === null) {
      knopf.setAttribute('data-alt-text', knopf.innerHTML);
      alt = knopf.innerHTML;
    }
    knopf.innerHTML = text;
    knopf.disabled = true;
    setTimeout(function () {
      knopf.innerHTML = alt;
      knopf.disabled = false;
    }, 1400);
  }

  /* --- Schublade ---------------------------------------------------- */

  function inhaltTauschen(sektionen) {
    if (!sektionen || !sektionen[SEKTION]) return;
    var ziel = document.querySelector(SCHUBLADE + ' ' + INHALT);
    if (!ziel) return;
    var geparst = new DOMParser().parseFromString(sektionen[SEKTION], 'text/html');
    var neu = geparst.querySelector(INHALT);
    if (neu) ziel.innerHTML = neu.innerHTML;
  }

  function oeffnen() {
    var s = schublade();
    if (!s || s.classList.contains('gs-minicart--offen')) return;
    letzterFokus = document.activeElement;
    s.classList.add('gs-minicart--offen');
    document.documentElement.classList.add('gs-korb-offen');
    var zu = s.querySelector('.gs-minicart__zu');
    if (zu) zu.focus();
  }

  function schliessen() {
    var s = schublade();
    if (!s || !s.classList.contains('gs-minicart--offen')) return;
    s.classList.remove('gs-minicart--offen');
    document.documentElement.classList.remove('gs-korb-offen');
    // Zurueck auf den Knopf, von dem aus geoeffnet wurde. Ohne das steht der
    // Fokus danach am Seitenanfang.
    if (letzterFokus && letzterFokus.focus && document.contains(letzterFokus)) {
      letzterFokus.focus();
    }
    letzterFokus = null;
  }

  // Menge aendern und entfernen (Menge 0). Antwort von /cart/change.js ist der
  // ganze Warenkorb, inklusive der neu gerenderten Sektion. Kommt von den
  // Plus/Minus-Knoepfen und seit 2026-09-22 auch vom Eingabefeld dazwischen.
  function mengeAendern(zeile, menge) {
    if (isNaN(zeile) || isNaN(menge) || menge < 0) return;
    var panel = schublade();
    if (panel) panel.classList.add('gs-minicart--laedt');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: zeile,
        quantity: menge,
        sections: SEKTION
      }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change ' + r.status);
        return r.json();
      })
      .then(function (korb) {
        inhaltTauschen(korb.sections);
        zaehlerSetzen(korb.item_count);
        zahlSetzen(korb.item_count);
        document.dispatchEvent(new CustomEvent('gs:warenkorb', { detail: korb }));
      })
      .catch(function () {
        // Im Zweifel auf die Warenkorbseite, dort geht das Aendern ohne
        // JavaScript. Besser als eine Schublade, die stumm nichts tut.
        window.location = warenkorbAdresse();
      })
      .then(function () {
        if (panel) panel.classList.remove('gs-minicart--laedt');
      });
  }

  /* --- Versandkosten vorab ------------------------------------------- */

  // GF 2026-09-22: Versandkosten schon im Warenkorb zeigen, nicht erst im
  // Kassenbereich. Markup in snippets/gs-versandrechner.liquid. Quelle ist
  // Shopifys /cart/shipping_rates.json, die mit den echten Versandprofilen
  // fuer genau diesen Warenkorb rechnet; sie braucht die PLZ. Die PLZ wird
  // gemerkt, damit nach einer Mengenaenderung (Seite neu, Schublade neu
  // gerendert) die Zahl von selbst wieder dasteht.
  var PLZ_SCHLUESSEL = 'gs-versand-plz';

  function plzGemerkt() {
    try { return localStorage.getItem(PLZ_SCHLUESSEL) || ''; } catch (e) { return ''; }
  }

  function plzMerken(plz) {
    try { localStorage.setItem(PLZ_SCHLUESSEL, plz); } catch (e) { /* privater Modus */ }
  }

  // Gleiche Schreibweise wie Shopifys money-Filter im Shop: "€6,90".
  function geld(betrag) {
    return '€' + betrag.toFixed(2).replace('.', ',');
  }

  function versandRechnen(block) {
    if (!block) return;
    var feld = block.querySelector('[data-gs-versand-plz]');
    var ausgabe = block.querySelector('[data-gs-versand-ergebnis]');
    if (!feld || !ausgabe) return;
    var plz = feld.value.trim();
    // Faktor 100 = netto (Gewerbe), 119 = brutto (Privat), wie gs_f in Liquid.
    var faktor = Number(block.getAttribute('data-faktor')) || 100;

    if (!/^\d{5}$/.test(plz)) {
      block.classList.add('gs-versand--fehler');
      ausgabe.textContent = 'Bitte eine fünfstellige Postleitzahl eingeben.';
      return;
    }
    block.classList.remove('gs-versand--fehler');
    ausgabe.textContent = 'wird berechnet …';

    var url = '/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(plz) +
              '&shipping_address[country]=Germany';

    // Shopify antwortet mit 202, solange es noch rechnet; dann kurz warten
    // und noch einmal fragen. ponytail: fuenf Versuche, danach Fehlertext.
    function holen(versuch) {
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 202 && versuch < 5) {
            return new Promise(function (ok) { setTimeout(ok, 800); })
              .then(function () { return holen(versuch + 1); });
          }
          return r.json().then(function (d) {
            if (!r.ok) throw d;
            return d;
          });
        });
    }

    holen(0)
      .then(function (d) {
        var raten = d.shipping_rates || [];
        ausgabe.textContent = '';
        if (!raten.length) {
          ausgabe.textContent = 'Für diese PLZ liegt kein Versandtarif vor, der Kassenbereich zeigt die Möglichkeiten.';
          return;
        }
        raten.forEach(function (rate, i) {
          if (i) ausgabe.appendChild(document.createElement('br'));
          ausgabe.appendChild(document.createTextNode(rate.name + ': '));
          var stark = document.createElement('strong');
          stark.textContent = geld(Number(rate.price) * faktor / 100);
          ausgabe.appendChild(stark);
        });
        plzMerken(plz);
      })
      .catch(function (fehler) {
        block.classList.add('gs-versand--fehler');
        ausgabe.textContent = (fehler && fehler.zip && fehler.zip[0]) ||
          'Versandkosten konnten gerade nicht ermittelt werden.';
      });
  }

  // Alle Bloecke auf der Seite mit der gemerkten PLZ fuellen und rechnen.
  // Laeuft beim Laden und nach jedem Warenkorb-Ereignis (die Schublade wird
  // dann neu gerendert, das Feld ist wieder leer).
  function versandAuffrischen() {
    var plz = plzGemerkt();
    if (!plz) return;
    var bloecke = document.querySelectorAll('[data-gs-versand]');
    for (var i = 0; i < bloecke.length; i++) {
      var feld = bloecke[i].querySelector('[data-gs-versand-plz]');
      if (feld && !feld.value) feld.value = plz;
      versandRechnen(bloecke[i]);
    }
  }

  /* --- Ereignisse ---------------------------------------------------- */

  // Eingetippte Mengen. In der Schublade geht die Zahl an /cart/change.js,
  // im Warenkorb wird das Cart-Formular abgeschickt (Shopifys updates[]),
  // damit niemand mehr den Link "Mengen uebernehmen" suchen muss. `change`
  // feuert bei Enter und beim Verlassen des Felds, nicht bei jedem Tastendruck.
  document.addEventListener('change', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;

    if (ziel.hasAttribute('data-gs-minicart-feld')) {
      var menge = Math.floor(Number(ziel.value));
      if (isNaN(menge) || menge < 0) { ziel.value = ziel.defaultValue; return; }
      mengeAendern(Number(ziel.getAttribute('data-zeile')), menge);
      return;
    }

    if (ziel.name && ziel.name.indexOf('updates[') === 0 && ziel.form) {
      if (ziel.value === ziel.defaultValue) return;
      if (ziel.form.requestSubmit) ziel.form.requestSubmit(); else ziel.form.submit();
      return;
    }

    if (ziel.hasAttribute('data-gs-versand-plz')) {
      versandRechnen(ziel.closest('[data-gs-versand]'));
    }
  });

  // Enter im PLZ-Feld rechnet, statt im Warenkorb das ganze Formular
  // abzuschicken. Enter im Mengenfeld des Warenkorbs verlaesst nur das Feld:
  // `change` oben schickt dann ab, und der Browser schickt nicht noch einmal.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || !e.target.hasAttribute) return;
    if (e.target.hasAttribute('data-gs-versand-plz')) {
      e.preventDefault();
      versandRechnen(e.target.closest('[data-gs-versand]'));
    } else if (e.target.name && e.target.name.indexOf('updates[') === 0) {
      e.preventDefault();
      e.target.blur();
    }
  });

  document.addEventListener('gs:warenkorb', versandAuffrischen);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versandAuffrischen);
  } else {
    versandAuffrischen();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    // Nur abfangen, wenn wir es auch koennen.
    if (!window.fetch || !window.FormData) return;

    // Shopifys Express-Kassen (Shop Pay, PayPal, Apple Pay, Google Pay) haengen
    // im SELBEN Produktformular, gerendert von `payment_button`. Sie fuehren
    // direkt in die Kasse und nicht in den Warenkorb. Ohne diese Ausnahme
    // fangen wir sie mit ab, und der Kunde landet in der Schublade statt beim
    // Bezahlen. `submitter` sagt, welcher Knopf abgeschickt hat.
    if (e.submitter && e.submitter.closest &&
        e.submitter.closest('.shopify-payment-button')) {
      return;
    }

    e.preventDefault();
    var knopf = form.querySelector('button[type="submit"], input[type="submit"]');
    var daten = new FormData(form);
    // Der Rueckweg ist im Formular fuer den Fall ohne JavaScript hinterlegt.
    // Hier stoert er nur, die Antwort soll JSON sein.
    daten.delete('return_to');
    // Nur anfordern, wenn die Sektion auch auf der Seite steht. Sonst
    // beschwert sich die Schnittstelle ueber einen unbekannten Namen.
    if (schublade()) daten.append('sections', SEKTION);

    fetch('/cart/add.js', {
      method: 'POST',
      body: daten,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      })
      .then(function (antwort) {
        inhaltTauschen(antwort.sections);
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (korb) {
        zaehlerSetzen(korb.item_count);
        zahlSetzen(korb.item_count);
        rueckmeldung(knopf, 'Im Warenkorb');
        oeffnen();
        document.dispatchEvent(new CustomEvent('gs:warenkorb', { detail: korb }));
      })
      .catch(function () {
        // Im Zweifel den gewohnten Weg gehen, statt den Kunden ohne
        // Rueckmeldung stehen zu lassen.
        form.submit();
      });
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    if (e.target.closest('[data-gs-minicart-zu]')) {
      e.preventDefault();
      schliessen();
      return;
    }

    var mengenknopf = e.target.closest('[data-gs-minicart-menge]');
    if (mengenknopf) {
      e.preventDefault();
      if (mengenknopf.disabled) return;
      mengeAendern(Number(mengenknopf.getAttribute('data-zeile')),
                   Number(mengenknopf.getAttribute('data-menge')));
      return;
    }

    var versandknopf = e.target.closest('[data-gs-versand-los]');
    if (versandknopf) {
      e.preventDefault();
      versandRechnen(versandknopf.closest('[data-gs-versand]'));
      return;
    }

    // Der Warenkorbknopf im Kopf oeffnet die Schublade, statt die Seite zu
    // wechseln. Das href bleibt im Markup: ohne Skript, per Rechtsklick und
    // in neuem Tab fuehrt er weiter auf die Warenkorbseite.
    var korbknopf = e.target.closest(KORB);
    if (korbknopf && schublade() && window.fetch) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      oeffnen();
    }
  });

  document.addEventListener('keydown', function (e) {
    var s = schublade();
    if (!s || !s.classList.contains('gs-minicart--offen')) return;

    if (e.key === 'Escape') {
      schliessen();
      return;
    }

    // Fokus in der Schublade halten. Ein Dialog, aus dem man hinter den
    // Vorhang tabbt, ist fuer Tastatur und Vorleseprogramm kaputt.
    if (e.key !== 'Tab') return;
    var panel = s.querySelector('.gs-minicart__panel');
    if (!panel) return;
    var ziele = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!ziele.length) return;
    var erste = ziele[0];
    var letzte = ziele[ziele.length - 1];
    if (e.shiftKey && document.activeElement === erste) {
      e.preventDefault();
      letzte.focus();
    } else if (!e.shiftKey && document.activeElement === letzte) {
      e.preventDefault();
      erste.focus();
    }
  });
})();
